<template>
  <div>
    <div id="inputGroup" class="input-group input-group-sm">
      <div class="input-group-prepend" :style="getWidth">
        <span class="input-group-text small justify-content-sm-end" id="basic-addon1">{{ prepend }}</span>
      </div>
      <div class="input-group-append flex-grow-1">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputGroupForm',
  props: {
    prepend: {
      type: String,
      default: ""
    },
    widthPrepend: {
      type: String,
      default: "20"
    },
    align: {
      type: String,
      default: ""
    },
  },
  computed: {
    getWidth() {
      return 'flex: 0 0 ' + this.widthPrepend + '%;'
    },
    prependClass() {
      return this.widthPrepend ? '' : 'default-prepend';
    }
  }
}
</script>

<style>
#inputGroup .input-group-text {
  width: 100%;
}

#basic-addon1 {
  background-color: #3c3f40;
  color: white;
}

.default-prepend {
  min-width: 60px;
}
</style>
